






















import { Vue, Component, Prop } from 'vue-property-decorator';
import ImageTextVideoBlock from './ImageTextVideoBlock.vue';
import AdnuntiusPixels from '@/project/tracking/adnuntius/AdnuntiusPixels.vue';
import { AdContentBlockViewModel, ProductTileViewObject } from '@/types/apiServerContract';
import adnuntiusService from '@/project/personalization/adnuntius.service';
import { AdnuntiusTrackingData } from '@/project/tracking/adnuntius/types';
import Api from '@/project/http/Api.service';
import { uniqBy } from 'lodash';
import urlHelperService from '@/core/urlHelper.service';

@Component({
    components: { AdnuntiusPixels, ImageTextVideoBlock }
})
export default class AdnuntiusProductBannerBlock extends Vue {
    @Prop({ type: Array, required: true })
    private products!: ProductTileViewObject[];

    @Prop({ required: true, type: String })
    private listLocation!: string;

    @Prop({ required: true, type: String })
    private brandName!: string;

    private adContentBlockViewModel: AdContentBlockViewModel | null = null;
    private contentLoadError = false;
    private adnuntiusTrackingData: AdnuntiusTrackingData | null = null;
    private loading = true;

    private created() {
        this.getAdContent();
    }

    private async getAdContent() {
        try {
            this.loading = true;
            this.adContentBlockViewModel = await Api.personalization.productListBanner({
                listLocation: this.listLocation,
                contactKey: adnuntiusService.getContactKey(),
                customerKey: adnuntiusService.getCustomerKey(),
                currentUrl: this.$route.fullPath,
                brandName: this.brandName,
                itemIds: this.products.map(x => x.itemId),
                brands: uniqBy(this.products.map(x => x.brand), x => x),
                categoryIds: uniqBy(this.products.filter(x => !!x.categoryId).map(x => x.categoryId as string), x => x),
                searchTerm: urlHelperService.getTerm()
            });

            if (this.adContentBlockViewModel.lineItemId && this.adContentBlockViewModel.creativeId) {
                this.adnuntiusTrackingData = {
                    lineItemId: this.adContentBlockViewModel.lineItemId,
                    creativeId: this.adContentBlockViewModel.creativeId,
                    parentBlockAlias: 'productBannerBlock'
                };
            }
            this.loading = false;
        } catch {
            this.contentLoadError = true;
        }
    }

    private get renderedPixelUrl() {
        return this.adContentBlockViewModel?.renderedPixelUrl;
    }

    private get viewPixelUrl() {
        return this.adContentBlockViewModel?.viewPixelUrl;
    }

    private get visiblePixelUrl() {
        return this.adContentBlockViewModel?.visiblePixelUrl;
    }

    private get clickPixelUrl() {
        return this.adContentBlockViewModel?.clickPixelUrl;
    }
}
